import "./scss/style.scss";
import App from "./js/App.js";

window.onload = () => {
  new App();
};
